(function(){
  'use strict';
  var bar = document.querySelector('.cdn-mm-bar');
  if (!bar) return;

  var items = bar.querySelectorAll('.cdn-mm-item--has-panel');
  var toggle = bar.querySelector('.cdn-mm-toggle');
  var openItem = null;
  var closeTimer = null;
  var DESKTOP_MIN = 961;

  function isDesktop(){ return window.innerWidth >= DESKTOP_MIN; }

  function close(item){
    if (!item) return;
    item.classList.remove('is-open');
    var link = item.querySelector('.cdn-mm-link');
    if (link) link.setAttribute('aria-expanded', 'false');
    if (openItem === item) openItem = null;
  }

  function open(item){
    if (openItem && openItem !== item) close(openItem);
    item.classList.add('is-open');
    var link = item.querySelector('.cdn-mm-link');
    if (link) link.setAttribute('aria-expanded', 'true');
    openItem = item;
  }

  items.forEach(function(item){
    var link = item.querySelector('.cdn-mm-link');
    if (!link) return;

    item.addEventListener('mouseenter', function(){
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      open(item);
    });
    item.addEventListener('mouseleave', function(){
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function(){ close(item); }, 180);
    });

    link.addEventListener('click', function(e){
      if (isDesktop()) return;
      e.preventDefault();
      if (item.classList.contains('is-open')) close(item);
      else open(item);
    });

    link.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' ') {
        if (isDesktop()) {
          e.preventDefault();
          if (item.classList.contains('is-open')) close(item);
          else open(item);
        }
      }
    });
  });

  if (toggle) {
    toggle.addEventListener('click', function(){
      var isOpen = bar.classList.toggle('is-mobile-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (!isOpen && openItem) close(openItem);
    });
  }

  document.addEventListener('click', function(e){
    if (!bar.contains(e.target) && openItem) close(openItem);
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') {
      if (openItem) close(openItem);
      bar.classList.remove('is-mobile-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  });

  var resizeTimer;
  window.addEventListener('resize', function(){
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function(){
      if (isDesktop() && bar.classList.contains('is-mobile-open')) {
        bar.classList.remove('is-mobile-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    }, 150);
  });
})();
